import React from "react";
import styled, { useTheme } from "styled-components";
import CustomFlapOut from "./CustomFlapOut";
import HelpFlap from "./HelpFlap";
import { useGeneralState } from "../../../redux/general/selectors";
import { logOut } from "../../../redux/general/auth";
import { useDispatch } from "react-redux";
import {
  TypographyNew,
  TextVariant,
} from "../../../global/typography/typography";
import EmployeeAvatarNew from "../../../global/avatars/EmployeeAvatarNew";
import { baseUrl } from "../../../config/globalVariables";
import MenuItemNew from "../../../global/formFields/staticSelect/MenuItemNew";
import { useHistory } from "react-router-dom";
import Search from "./Search/Search";
import { useBreakpoint } from "../../../utils/hooks";
import NotificationFlap from "./NotificationFlap";
import { Role } from "../../../redux/api-model/organization/company";
// import IconButtonNew from "../../../global/buttonsLinks/IconButtonNew";
// import { faComments } from "@fortawesome/pro-solid-svg-icons";
// import Authorized from "../../../global/common/Authorized";
import { useTranslation } from "react-i18next";
import { ReactComponent as HeavenLogo } from "../../../global/assets/heavenhr-logo.svg";
import { backDrop } from "../../../utils/z-index";
import useContractProfileLink from "../../../global/common/useContractProfileLink";

// styles
//if z index higher than three it blocks registration flow. so 3 is max on topbar, or alternatively fix signup flow.
const TopBarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: ${backDrop};
  height: 80px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0 2px 4px #4c4c4c24;
  display: flex;
`;

const TextFieldContainer = styled.div`
  max-width: 450px;
  min-width: 200px;
  margin-top: 20px;
  align-self: baseline;
  flex: 1;
  margin-left: 50px;

  @media (min-width: 1440px) {
    max-width: 600px;
    margin-left: 0;
  }
`;

const RightContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  height: 100%;
  flex-direction: row;
  align-items: center;
`;

const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin: 0 auto;
  max-width: 1210px;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 77px;
  padding: 10px;

  @media (min-width: 1280px) {
    width: 178px;
  }
`;

export const TopBarLogo = styled.img`
  width: auto;
  height: 38px;
  object-position: left;
  object-fit: cover;
  margin-left: 10px;
  margin-right: 10px;
  &:hover {
    cursor: pointer;
  }

  @media (min-width: 600px) {
    width: unset;
  }
`;

const LogoContainer = styled.div`
  width: 123px;
  cursor: pointer;
`;

// components
const TopBar: React.FC = () => {
  const { isMobile, isDesktop } = useBreakpoint();
  const theme = useTheme();
  const general = useGeneralState();

  const history = useHistory();
  const dispatch = useDispatch();
  const self = useGeneralState().self;
  const { t } = useTranslation();
  const { link: profileLink } = useContractProfileLink();

  const handleLogoClick = () => {
    history.push(profileLink);
  };

  return (
    <TopBarContainer>
      <LeftContainer>
        {general.userSelection.type == Role.WORK_CONTRACT_ACCESS ||
        !isDesktop ? (
          <LogoContainer onClick={handleLogoClick}>
            <HeavenLogo />
          </LogoContainer>
        ) : null}
        {!isMobile &&
        general.userSelection.type !== Role.WORK_CONTRACT_ACCESS ? (
          <TextFieldContainer>
            <Search endpoint="/employees/search" />
          </TextFieldContainer>
        ) : null}
      </LeftContainer>
      <RightContainer>
        <HelpFlap />
        {/* <Authorized visibleFor={[Role.DEPARTMENT_ACCESS, Role.COMPANY_ACCESS]}>
          <IconButtonNew
            focused={false}
            onClick={() => {
              history.push("/app/community");
            }}
            icon={faComments}
          />
        </Authorized> */}
        <NotificationFlap />
        <CustomFlapOut
          mainComponent={
            <ProfileContainer>
              {isDesktop ? (
                <TypographyNew
                  noWrap
                  variant={TextVariant.subtitle2}
                  marginRight={"20px"}
                >
                  {self.data?.firstName || ""} {self.data?.lastName || ""}
                </TypographyNew>
              ) : null}
              <EmployeeAvatarNew
                imgUrl={
                  self.data?.imgLink
                    ? baseUrl + "/file/account/" + self.data.imgLink
                    : undefined
                }
                size={"SMALL"}
              />
            </ProfileContainer>
          }
        >
          {general.userSelection.type == Role.COMPANY_ACCESS &&
          general.self.data.hasWorkContracts !== false ? (
            <MenuItemNew
              onClick={() =>
                history.push(
                  `/app/employees/` + self.data.employeeId + "/overview"
                )
              }
            >
              <TypographyNew
                variant={TextVariant.subtitle2}
                color={theme.colors.grays1}
              >
                {t("general:myProfile")}
              </TypographyNew>
              <TypographyNew
                variant={TextVariant.body1}
                color={theme.colors.grays3}
              >
                {t("general:myProfileDescription")}
              </TypographyNew>
            </MenuItemNew>
          ) : (
            <></>
          )}
          <MenuItemNew onClick={() => history.push("/app/account")}>
            <TypographyNew
              variant={TextVariant.subtitle2}
              color={theme.colors.grays1}
            >
              {t("general:settings")}
            </TypographyNew>
            <TypographyNew
              variant={TextVariant.body1}
              color={theme.colors.grays3}
            >
              {t("general:settingsDescription")}
            </TypographyNew>
          </MenuItemNew>
          <MenuItemNew onClick={() => dispatch(logOut())}>
            <TypographyNew
              variant={TextVariant.subtitle2}
              color={theme.colors.grays1}
            >
              {t("general:logout")}
            </TypographyNew>
          </MenuItemNew>
        </CustomFlapOut>
      </RightContainer>
    </TopBarContainer>
  );
};

export default TopBar;
